import { gql } from 'apollo-angular';
import { TypedDocumentNode } from '@apollo/client';
import { landlordDistrictGroup, landlordObjectTypes } from '@ui/legacy-lib';
import {
  BrandingResponse,
  CustomerBrandingResponse
} from '../../+state/branding/branding.effects';

export const landlordBrandingQuery: TypedDocumentNode<BrandingResponse> = gql`
  query landlordBranding($input: ValidateTokenInput!) {
    landlordBranding(input: $input) {
      name
      primaryColor
      secondaryColor
      primaryTextColor
      secondaryTextColor
      buttonTextColor
      backgroundColor
      cardBackgroundColor
      active
      customerId
      onlyShowConfiguredCityPartsToUser
      allowUserToLeaveItp
      customerName
      customerIdent
      tokenId
      logo {
        url
        title
      }
      favicon {
        url
      }
      logoRedirectUrl
      captchaSettings {
        siteKey
        whitelabelRegistrationProcessActive
      }
      districtGroup {
        ${landlordDistrictGroup}
      }
      objectTypes {
        ${landlordObjectTypes}
      }
    }
  }
`;

export const customerBrandingQuery: TypedDocumentNode<CustomerBrandingResponse> = gql`
  query landlordBranding($customerId: ID) {
    customerBranding(customerId: $customerId) {
      name
      logo
    }
  }
`;
